import { JSEncrypt } from 'jsencrypt'


const publicKey = 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCwlNLxgsV9615nyMd1II9Omm5D2S2RQ6wGanWUySqK8aWI5Z4823q+B1hYV3fuCxm+9VisRo7Goeg9WfHl5eU4QFdbrpbaDWvLzoW9DEHIamcR4ESMwQN7MTATW6DJ+Ez7zTBaOy+xS/pXFCLGRDP5iAl7Yfl7H5NvxVSZ3xbQxQIDAQAB'


// 加密
export function encrypt(txt) {
  const encryptor = new JSEncrypt()
  encryptor.setPublicKey(publicKey) // 设置公钥
  return encryptor.encrypt(txt) // 对数据进行加密
}

